import { Injectable } from "@angular/core";
import { NGXLogger } from "ngx-logger";

@Injectable({ providedIn: "root" })
export class LocalStorageService {
  constructor(private logger: NGXLogger) {}

  persist(key: string, value: any) {
    this.logger.debug(`LOCAL STORAGE: persist '${key}'`);
    localStorage.setItem(key, JSON.stringify(value));
  }

  load(key: string) {
    const stringValue = localStorage.getItem(key);
    if (!stringValue) {
      this.logger.debug(`LOCAL STORAGE: '${key}' doesn't exists`);
      throw new Error(`${key} doesn't exists in local storage`);
    }
    const value = JSON.parse(stringValue);
    this.logger.debug(`LOCAL STORAGE: '${key}' loaded`);
    return value;
  }
}
